import { Input, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'scaleautoactivation',
  templateUrl: './scale-auto-activation.component.html',
  styleUrls: ['./scale-auto-activation.component.scss']
})
export class ScaleAutoActivationComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    let code = this.route.snapshot.paramMap.get('code');
    sessionStorage.setItem("activationCode", code);
    this.router.navigate(["login"]);
  }
}
